import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { Accordion, AccordionTab } from "primereact/accordion";
import { IPermissionProps } from "../../../models/Login";
import { Fetch, ILazyParams } from "../../../shared/Fetch";
import { EmptyBidTeam, IBidTeamMast, IModel } from "./RFP_Bid_TeamManagement";
import { BidTeamEmptySkillFilter, Filter, IBidTeamSkillFilter } from "./Filter";

interface Iprops {
  setModal: (modal: IModel) => void;
  toast: any;
  reload: boolean;
  permissions: IPermissionProps;
  setReload: (is: boolean) => void;
  setModal2: (modal: { open: boolean; singleData: RowData }) => void;
}

export interface ITeamMast {
  branch?: string;
  company?: string;
  team_ID?: number;
  team_Manager?: string;
  team_Name?: string;
}

export interface RowData {
  branch?: string;
  branch_ID?: number;
  company?: string;
  company_ID?: number;
  createdOn?: Date;
  status?: boolean;
  team_ID?: number;
  team_Manager?: string;
  team_Manager_ID?: number;
  team_Name?: string;
  user_Added_by?: number;
  category?: string;
  category_ID?: number;
}

export const Table = (props: Iprops) => {
  const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IBidTeamMast>; loading: boolean });
  const [defaultTableData, setDefaultTableData] = useState({ tableData: [] } as { tableData: Array<IBidTeamMast> });
  const [lazyParams, setLazyParams] = useState<ILazyParams>({
    first: 0,
    rows: 25,
    page: 1,
    sortField: "consultant_ID",
    sortOrder: -1,
  });
  const [totalRecords, setTotalRecords] = useState(0);
  const [skillFilter, setSkillFilter] = useState<IBidTeamSkillFilter>(BidTeamEmptySkillFilter);

  const dt = useRef<any>(null);

  const openNew = () => {
    props.setModal({ open: true, singleData: EmptyBidTeam, teamNameList: defaultTableData.tableData });
  };

  const openEdit = (rowData: RowData) => {
    let data: any = {
      Team_ID: rowData.team_ID,
      Team_Name: rowData.team_Name,
      Status: rowData.status,
      Company_Name: rowData.company_ID,
      Branch_Name: rowData.branch_ID,
      TeamManagerid: rowData.team_Manager_ID,
      CreatedOn: rowData.createdOn,
      User_Added_by: rowData.user_Added_by,
      Tender_Client_Category: rowData.category_ID,
    };

    props.setModal({ open: true, singleData: data, teamNameList: defaultTableData.tableData });
  };

  const getTableDataCount = async () => {
    const response = await Fetch("RPF_Bid_Team_Management/count", "GET", null, null, props.toast);
    if (response) {
      const count: number = parseInt(await response.text(), 10);
      setTotalRecords(count);
    }
  };

  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <div className="my-2">
          <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
        </div>
      </React.Fragment>
    );
  };

  const rightToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button label="Export" icon="pi pi-upload" className="p-button-help" />
      </React.Fragment>
    );
  };

  const header = (
    <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
      <h5 className="m-0">RFP Bid Team </h5>
      <span className="block mt-2 md:mt-0 p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          placeholder="Search By Bid Team Name"
          onChange={(e) => {
            let data = defaultTableData.tableData.filter((el) => el.team_Name?.toLowerCase().includes(e.target.value.toLowerCase()));
            setTableData({ tableData: data, loading: false });
          }}
        />
      </span>
    </div>
  );

  const loadTableData = async () => {
    setTableData({ tableData: tableData.tableData, loading: true });
    const response = await Fetch("RPF_Bid_Team_Management", "GET", null, `lazyParams=${encodeURIComponent(JSON.stringify(lazyParams))}&filters=${encodeURIComponent(JSON.stringify(skillFilter))}`, props.toast);
    if (response) {
      const data: Array<ITeamMast> = await response.json();
      setTableData({ tableData: data, loading: false });
      setDefaultTableData({ tableData: data });
    }
  };

  const RemoveTeam = async (rowData: RowData) => {
    setTableData({ tableData: tableData.tableData, loading: true });
    const response = await Fetch("RPF_Bid_Team_Management", "DELETE", null, `team_ID=${rowData.team_ID}`, props.toast);
    if (response) {
      props.toast.current.show({ severity: "success", detail: "Team Removed", life: 3000 });
      loadTableData();
    }
  };

  const rejectFunc = () => {
    props.toast.current.show({ severity: "error", detail: "You have Canceled", life: 3000 });
  };

  const confirmDelete = (rowData: any) => {
    confirmDialog({
      message: `Are you sure you want to delete this team`,
      header: "Confirm Delete",
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-danger",
      accept: () => RemoveTeam(rowData),
      reject: () => rejectFunc(),
    });
  };

  const action = (rowData: RowData) => {
    return (
      <div className="flex gap-3">
        {/* <Button className="pi pi-clock text-primary bg-white border-none" onClick={() => setHistoryModal({ open: true, teamId: rowData.team_ID ?? 0 }) } /> */}
        <Button className="pi pi-pencil text-primary bg-white border-none" onClick={() => openEdit(rowData)}></Button>
        <Button className="pi pi-external-link text-primary bg-white border-none" onClick={() => props.setModal2({ open: true, singleData: rowData })}></Button>
        <Button className="pi pi-trash text-primary bg-white border-none" onClick={() => confirmDelete(rowData)}></Button>
      </div>
    );
  };

  useEffect(() => {
    if (lazyParams.rows) {
      getTableDataCount();
      loadTableData();
    } else {
      loadTableData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lazyParams, props.reload, skillFilter]);

  useEffect(() => {
    getTableDataCount();
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
      <Accordion>
        <AccordionTab header="Filter">
          <Filter skillFilter={skillFilter} setSkillFilter={(skillFilter: IBidTeamSkillFilter) => setSkillFilter(skillFilter)} />
        </AccordionTab>
      </Accordion>
      <DataTable style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0" }} ref={dt} size="small" stripedRows scrollable scrollHeight="75vh" sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder} value={tableData.tableData} emptyMessage="No Requirements found." header={header} loading={tableData.loading}>
        <Column header="SN." body={(data, options) => options.rowIndex + 1} />
        <Column field="team_Name" header="Bid Team Name" />
        <Column field="company" header="Company" />
        <Column field="branch" header="Branch" />
        <Column field="team_Manager" header="Team Manager" />
        <Column field="category" header="RFP Category" />
        <Column field="" header="Action" body={action} />
      </DataTable>
      <ConfirmDialog />
    </>
  );
};
